import React from 'react';
import { useToggle, useFetch } from 'hooks';
import { matchPath } from 'react-router-dom';
import { routes } from 'constants/config';
import ModalContainer from 'components/shared/modal/modal_container';
import { Modal, ButtonGroup, Button, Icon, Spinner } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import ScrollableContainer from 'components/shared/scrollable';
import File from './File';

const match = () =>
  matchPath(window.location.pathname, {
    path: '/lessons/:lessonId',
  });

const ScormMultipleDownload = () => {
  const lessonId = match()?.params?.lessonId;
  const [modalVisible, toggleModalVisible] = useToggle();
  const { data: files, initialLoading } = useFetch(
    routes.SCORM_FILES(lessonId),
  );

  if (initialLoading)
    return (
      <div className="px-32 mt-8">
        <Spinner />
      </div>
    );

  return (
    <>
      <button
        className="SidebarModule-padded mt-8 u-linkBtn"
        type="button"
        onClick={toggleModalVisible}
        data-testid="multiple-scorm-files-button"
      >
        <Icon className="mr-11" name="download" />
        {t('actions.download_elearning_files')}
      </button>
      {modalVisible && (
        <ModalContainer onEscape={toggleModalVisible}>
          <Modal
            className="LessonVersionModal-wrapper MultipleDownload bg-gray-lightest"
            shown={modalVisible}
            onDismiss={toggleModalVisible}
            enableFloatingDismiss
          >
            <Modal.Content className="d-f fd-c">
              <h1 className="LessonVersionModal-title pb-8 ff-ss fw-n">
                {t('actions.download_multiple_scorm_files_modal.modal_title')}
              </h1>
              <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="pb-24">
                {t('actions.download_multiple_scorm_files_modal.modal_body')}
              </Text>
              <ScrollableContainer
                className="PublishedVersionCollection-scrollable bg-white pr-0"
                maxHeight={null}
              >
                <ul>
                  <li className="PublishedVersionCollection-columnHeader d-f ff-ss fw-b fz-16">
                    <span className="ml-32">
                      {t(
                        'actions.download_multiple_scorm_files_modal.elearning_content',
                      )}
                    </span>
                  </li>
                  {files &&
                    files.map(({ fileName, fileDownloadUrl }) => (
                      <File
                        fileName={fileName}
                        fileDownloadUrl={fileDownloadUrl}
                        key={fileDownloadUrl}
                      />
                    ))}
                </ul>
              </ScrollableContainer>
            </Modal.Content>
            <ButtonGroup alignEnd className="pb-16 pr-32 pt-8">
              <Button onClick={toggleModalVisible}>{t('common.close')}</Button>
            </ButtonGroup>
          </Modal>
        </ModalContainer>
      )}
    </>
  );
};

export default ScormMultipleDownload;
